var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { noop, castArray } from '@ally/utilitarian';
/**
 * A small abstraction around Map for Map<K, Function>, that adds a `call`
 * method for invoking members. This helps from having to do (Map#get || noop)
 * everywhere.
 *
 * Note: TS/Webpack had issues extending map. So... composition it is.
 */
var FuncMap = /** @class */ (function () {
    function FuncMap(fallback, entries) {
        if (fallback === void 0) { fallback = noop; }
        this.store = new Map();
        this.get = this.store.get.bind(this.store);
        this.has = this.store.has.bind(this.store);
        this.set = this.store.set.bind(this.store);
        this.del = this.store.delete.bind(this.store);
        this.clear = this.store.clear.bind(this.store);
        this.fallback = fallback;
        this.add(entries);
    }
    /**
     * Convenience function for adding more than a single hook at a time.
     * Since `hook` are constructed on the Federator via composition, this allows
     * end-users to add items the constructor-like "entries" way.
     */
    FuncMap.prototype.add = function (entries) {
        var _this = this;
        entries === null || entries === void 0 ? void 0 : entries.forEach(function (_a) {
            var _b = __read(_a, 2), k = _b[0], v = _b[1];
            return _this.store.set(k, v);
        });
    };
    /**
     * Convenience function for adding a record of hooks.
     * Since `hook` are constructed on the Federator via composition, this allows
     * end-users to add items the constructor-like "entries" way.
     */
    FuncMap.prototype.register = function (record) {
        var _this = this;
        Object.entries(record).forEach(function (_a) {
            var _b = __read(_a, 2), key = _b[0], callback = _b[1];
            return callback && _this.store.set(key, callback);
        });
    };
    /**
     * Invokes the hook function(s) `k` with the provided arguments.
     */
    FuncMap.prototype.call = function (key) {
        var _a;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        castArray((_a = this.store.get(key)) !== null && _a !== void 0 ? _a : this.fallback).forEach(function (f) { return f.apply(void 0, __spread(args)); });
    };
    return FuncMap;
}());
export default FuncMap;
//# sourceMappingURL=FuncMap.js.map